import React, { FunctionComponent } from 'react';
import classNames from 'classnames';
import styles from './inputWrapper.module.css';

import { CheckIcon, WarningIcon } from '../SvgIcons';

export interface inputWrapperProps {
  label?: string;
  id?: string;
  error?: string;
  errormessage?: string;
  customWrapperClass?: string;
  children: JSX.Element;
  showHint?: boolean;
  hintmessage?: string;
}

export const InputWrapper: FunctionComponent<inputWrapperProps> = (props) => {
  const { children, label, id, error, errormessage, customWrapperClass, showHint, hintmessage } = props;

  const customWrapperClassParsed: string = typeof customWrapperClass === 'string' ? customWrapperClass : '';

  const classes = classNames({
    [styles.wrapper]: true,
    [customWrapperClassParsed]: true,
  });
  return (
    <div className={classes}>
      <label className={styles.label} htmlFor={id}>
        {label && label}
      </label>
      {children}
      <CheckIcon />
      <WarningIcon />
      {error && <div className={styles.errorMessage}>{errormessage}</div>}
      {showHint && <div className={styles.hintMessage}>{hintmessage}</div>}
    </div>
  );
};
